import { memo } from "react";

import { ViewPlaceholder } from "components/ui/ViewPlaceholder";

const SplitView = memo(() => {
    return <ViewPlaceholder placeholderSplitView>Select and click tab below to add it here</ViewPlaceholder>;
});

export default SplitView;
